export default {
  validation: "This field is mandatory",
};
